<template>
    <div class="modal " :class="{'is-active': showSmsModal==true}">
        <div class="modal-background"></div>
        <div class="modal-card"  style="width:840px;max-width:100%">
            <header class="modal-card-head">
                <p class="modal-card-title">Send SMS</p>
                <button class="delete" aria-label="close" @click="closeModal()"></button>
            </header>
            <section class="modal-card-body" >
                <div class="notification is-warning" v-if="loading == true">
                    Loading member details ...
                </div>
                
                
                <form @submit.prevent="sendSms()" v-if="loading==false">
                    <div class="field">
                    <label class="label">Member</label>
                    <div class="control">
                        <input class="input" type="text" :value="this.member.forename + ' ' + this.member.surname" disabled>
                    </div>
                    </div>
                    <div class="field">
                    <label class="label">Number</label>
                    <div class="control">
                        <input class="input" type="text" v-model="this.member.mobile" readonly disabled>
                    </div>
                    </div>
                    <div class="field" >
                        <label class="label">Compose SMS Content</label>
                        <div class="control">
                            <textarea class="textarea" placeholder="" v-model="sms_message" required @input="countCharacters"></textarea>
                            <p :class="{'has-text-danger' : characterCount >= 160}"><em>Character Count: {{ characterCount }}</em></p>
                        </div>
                    </div>
                    <div class="field is-grouped">
                    <div class="control">
                        <button class="button is-success" :disabled="working==true">Send Message</button>
                    </div>
                    
                    </div>
                </form>

                
            </section>
            
            <footer class="modal-card-foot" >
            <button class="button" @click="closeModal()" :disabled="working==true">Cancel</button>
            </footer>
        </div>
        
       
    </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

//import MemberGradeTags from '@/components/Generic/MemberGradeTags.vue';

export default {
    
      name: 'NewBookings',
        mixins: [MemberMixin],
        components: {
            
        },
        props: ['member_id', 'showSmsModal'],
        data: function () {
            return {
                   search: '',
                   booking: [],
                   searchPerformed: false,
                   assigned:false,
                   alertText: '',
                   member: [],
                   working:false,
                   loading: true,
                   sms_message: '',
                   characterCount: 0
            }
        },
        methods: {
            countCharacters() {
                this.characterCount = this.sms_message.length;
            },
            async getMember() {
                this.loading=true
                
                UtilityService.getSimpleApiData(this.accessToken, "members/" + this.member_id)
                .then(
                    (member => {
                        this.$set(this, "member", member);
                        this.loading = false
                    }).bind(this)
                );
            },
            
           
            async sendSms() {
                this.working = true

                if(confirm('Please double check the text you want to send and press OK to continue ?'))
                {
                    var formdata = { 
                        sms_message : this.sms_message,
                    }; 

                    MemberService.sendSms(this.accessToken, this.member.id, formdata)
                    .then(
                        () => {
                            this.working=false;
                            this.sms_message = ''
                            alert("SMS Sent")
                            this.closeModal()

                        }
                    ).catch((error) => { 
                        
                        alert(error.response.data.message)
                    
                    console.log(error.response.data)
                    this.working=false;
                });
                }
                else{
                    this.working=false;
                }

                
            },
            
            async closeModal() {
                this.$emit('close')
            },
            
        },
        computed : {
           
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                
            });
        
        },
        watch: {
            
            showSmsModal() {
                this.getMember();
                
            }
        },
    }
</script>